import { InfoCircledIcon } from "@radix-ui/react-icons";
import { match } from "ts-pattern";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "~/components/ui/toast";
import { useToast } from "~/components/ui/use-toast";

import { Icon } from "../Icon";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex items-center gap-1">
              {match(props.variant)
                .with("default", () => (
                  <Icon name="CHECKMARK" className="mr-3 size-6 shrink-0" stroke="white" />
                ))
                .with("message-success", () => <Icon name="CHECKFILLED" className="mr-3 size-6" />)
                .with("warning", "message-warning", () => (
                  <InfoCircledIcon className="mr-3 size-6 shrink-0" />
                ))
                .with("destructive", "message-destructive", () => (
                  <Icon name="WARNINGROUNDED" className="mr-3 size-6" />
                ))
                .with("info", "message-info", () => <InfoCircledIcon className="mr-3 size-6" />)
                .otherwise(() => null)}
              <div className="bg-token-token flex flex-col">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            {!props.variant?.includes("message") && <ToastClose />}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
